// Textes légaux UGC & CO — à faire relire par un professionnel avant la mise en vente.
const EDITOR = {
  name: "Mélanie Peyre",
  status: "Micro-entreprise (entrepreneuse individuelle)",
  siret: "en cours d'ajout",
  address: "1 bis chemin Belloc, 33530 Bassens, France",
  email: "mp.melaniepeyre@gmail.com",
  site: "ugcetco.com",
};

export const LEGAL_UPDATED = "juin 2026";

export const LEGAL = {
  "mentions-legales": {
    title: "Mentions légales",
    sections: [
      { t: "Éditrice du site", p: [
        `Le site ${EDITOR.site} (UGC & CO) est édité par ${EDITOR.name}, ${EDITOR.status}.`,
        `Adresse : ${EDITOR.address}.`,
        `SIRET : ${EDITOR.siret}.`,
        "TVA non applicable, article 293 B du Code général des impôts.",
        `Directrice de la publication : ${EDITOR.name}.`,
      ] },
      { t: "Contact", p: [`Email : ${EDITOR.email}.`] },
      { t: "Hébergement", p: [
        "Le site est hébergé par Emergent (emergent.sh), qui fournit l'infrastructure d'hébergement de l'application.",
      ] },
      { t: "Propriété intellectuelle", p: [
        "Les textes, contenus pédagogiques, logos, marques UGC & CO et UGC GO, visuels et éléments graphiques du site sont protégés. Toute reproduction ou diffusion, totale ou partielle, sans autorisation écrite de l'éditrice est interdite.",
        "Les contenus créés par les utilisatrices dans leurs exercices (scripts, notes, bilans) leur appartiennent.",
      ] },
      { t: "Responsabilité", p: [
        "UGC & CO propose des outils et contenus pédagogiques. Ils ne garantissent aucun résultat commercial, aucune collaboration rémunérée et aucun revenu.",
      ] },
    ],
  },
  cgv: {
    title: "Conditions générales de vente",
    sections: [
      { t: "1. Objet", p: [
        `Les présentes conditions régissent la vente des produits numériques proposés sur ${EDITOR.site} par ${EDITOR.name}, ${EDITOR.status}, ${EDITOR.address} (ci-après « l'éditrice »). Toute commande implique leur acceptation.`,
      ] },
      { t: "2. Produits", p: [
        "UGC GO — « Ma première vidéo UGC » est un parcours pédagogique en ligne en 7 missions (contenus, exercices interactifs, outils de préparation). Il s'agit d'un contenu numérique fourni sans support matériel.",
        "Le parcours aide à réaliser une vidéo UGC d'entraînement. Il ne garantit ni collaboration avec une marque, ni revenu.",
        "Les produits annoncés « Bientôt disponible » ne peuvent pas être commandés.",
      ] },
      { t: "3. Prix", p: [
        "Le parcours UGC GO est vendu 9 € TTC, en paiement unique, sans abonnement. TVA non applicable, article 293 B du CGI.",
        "Le prix applicable est celui affiché au moment de la commande.",
      ] },
      { t: "4. Commande et paiement", p: [
        "Pour commander, la cliente crée un compte, accepte les présentes conditions puis règle sa commande par carte bancaire sur la page de paiement sécurisée de Stripe. Aucune donnée bancaire n'est conservée par l'éditrice.",
        "Un reçu de paiement est disponible dans « Mon compte » après l'achat.",
      ] },
      { t: "5. Accès au produit", p: [
        "L'accès au parcours est ouvert dès la confirmation du paiement, depuis le compte de la cliente, sans limite de durée tant que le service est exploité.",
        "Un parcours acheté en cadeau donne lieu à un code à usage unique ; l'accès est ouvert au compte qui saisit ce code.",
      ] },
      { t: "6. Droit de rétractation", p: [
        "Conformément à l'article L221-28 13° du Code de la consommation, le droit de rétractation ne peut pas être exercé pour un contenu numérique fourni sans support matériel dont l'exécution a commencé avec l'accord préalable et exprès de la cliente, qui a reconnu perdre ce droit.",
        "Avant le paiement, la cliente demande l'accès immédiat au parcours et reconnaît renoncer à son droit de rétractation en cochant la case prévue à cet effet.",
      ] },
      { t: "7. Réclamations et médiation", p: [
        `Pour toute question ou réclamation : ${EDITOR.email}.`,
        "En cas de litige non résolu, la cliente peut recourir gratuitement à un médiateur de la consommation. Les coordonnées du médiateur seront précisées ici.",
      ] },
      { t: "8. Droit applicable", p: ["Les présentes conditions sont soumises au droit français."] },
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité",
    sections: [
      { t: "Responsable du traitement", p: [`${EDITOR.name}, ${EDITOR.address}. Contact : ${EDITOR.email}.`] },
      { t: "Données collectées", p: [
        "Compte : adresse email et informations de connexion.",
        "Parcours : tes réponses, scripts, notes et progression, enregistrés dans ton compte (et une copie dans ton navigateur).",
        "Achats : date, montant et statut du paiement. Les données de carte bancaire sont traitées uniquement par Stripe.",
        "Liste d'attente : adresse email et sujets qui t'intéressent.",
        "Les enregistrements de voix réalisés avec le minuteur de lecture restent sur ton appareil et ne nous sont jamais envoyés.",
      ] },
      { t: "Finalités", p: [
        "Créer et gérer ton compte, te donner accès aux produits achetés, sauvegarder ta progression, traiter les paiements, t'envoyer les emails liés à tes achats et, si tu t'y es inscrite, te prévenir de l'ouverture des nouveaux espaces.",
      ] },
      { t: "Prestataires", p: [
        "Clerk (connexion et comptes), Stripe (paiement), Resend (envoi des emails), Emergent (hébergement). Ces prestataires traitent les données uniquement pour fournir leur service.",
      ] },
      { t: "Durée de conservation", p: [
        "Les données du compte et du parcours sont conservées tant que le compte est actif. Les données de facturation sont conservées pendant la durée légale. Les inscriptions à la liste d'attente sont conservées jusqu'à l'ouverture de l'espace concerné ou jusqu'à ta désinscription.",
      ] },
      { t: "Tes droits", p: [
        `Tu peux accéder à tes données, les rectifier, les supprimer, t'opposer à leur traitement ou demander leur portabilité en écrivant à ${EDITOR.email}. Tu peux aussi introduire une réclamation auprès de la CNIL (cnil.fr).`,
      ] },
    ],
  },
};
